import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import mq from "../utils/mediaQueries";
import useWindowSize from "../hooks/useWindowSize";
import { breakpoints } from "../hooks/useBreakpoint";

const typewriter = keyframes`
  from{width: 10.75rem;}
  to{width: 14rem;}
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: ${({ theme }) => theme.header};
  margin: 0 0 1rem 0;
  align-items: center;
  justify-content: center;

  ${mq("sm")} {
    flex-direction: row;
  }
`;

const WiredLinkEstablished = styled.p`
  position: absolute;
  left: 0;
  padding: 0.25rem;
  color: ${({ theme }) => theme.black};
  overflow: hidden;
  white-space: nowrap;

  animation: ${typewriter} 4s steps(6) 1s infinite;
`;

const DeathBulletinBoardSystem = styled.p`
  font-size: 2.5vw;
  padding: 0.25rem;
  color: ${({ theme }) => theme.black};
  font-family: "Press Start 2P", monospace;

  ${mq("sm")} {
    font-size: 1rem;
  }
`;

const Banner = () => {
  const { width } = useWindowSize();

  return (
    <Wrapper>
      {width >= breakpoints.md && (
        <WiredLinkEstablished>Wired link established...</WiredLinkEstablished>
      )}
      <DeathBulletinBoardSystem>
        {"<<< DEATH BULLETIN BOARD SYSTEM >>>"}
      </DeathBulletinBoardSystem>
    </Wrapper>
  );
};

export default Banner;
